import {Component, OnDestroy, OnInit} from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { TandemUser } from '../../../auth/models/tandem-user';
import { DialogService } from '../../../tandem-core/services/dialog.service';
import { HeaderService } from '../../../tandem-core/services/header.service';
import {FormBuilder} from "@angular/forms";
import {VisionDialogComponent} from "../vision-dialog/vision-dialog.component";
import {UserService} from "../../../auth/user.service";
import {Subscription} from "rxjs";
import {CoreService} from "../../../tandem-core/services/core.service";
import {VideoPlayerComponent} from "../../../tandem-core/components/video-player/video-player.component";
import {TableConfiguration} from "../../../tandem-core/models/table-configuration";
import {Asset} from "../../../financial-positions/models/asset";
import {CurrencyService} from "../../../tandem-core/services/currency.service";
import {PercentPipe} from "@angular/common";
import {VideoType} from "../../../tandem-core/services/video-player.service";
import { ModalRef } from 'src/app/modules/tandem-core/models/modal-ref';
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Component({
  selector: 'tandem-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, OnDestroy {

  user: TandemUser | null = null;
  authSub?: Subscription;
  headerConfigSub?: Subscription;
  hasShownVideo = false;

  tableData: Asset[] = [];
  tableConfig: TableConfiguration<Asset> = {
    columns: [
      {
        title: 'Name',
        columnType: 'text',
        itemProperty: 'name'
      },
      {
        title: 'Value',
        columnType: 'value',
        itemProperty: 'value',
        displayMask: t => this.currencyService.formatNumber(t.value)
      },
      {
        title: 'Annual Interest',
        columnType: 'text',
        itemProperty: 'annualPercentageReturn',
        displayMask: t => this.currencyService.formatPercent(t.annualPercentageReturn),
      },
      {
        title: 'Ass Exp',
        columnType: 'text',
        itemProperty: 'associatedExpenses'
      },
    ],
     noDataMessage: "No assets available.", onRowClick(t: Asset): void {
    }, totalProp: undefined,
    title: 'My Assets',
    subtitle: 'A list of all the assets in your account including their name, value, and interest rate.',
    deleteRowFunction: t => this.tableData = this.tableData.splice(this.tableData.indexOf(t), 1)
  }

  showingVideo = false;
  private latestRef?: ModalRef;

  constructor(
    private auth: AuthService,
    private dialogService: DialogService,
    private headerService: HeaderService,
    private fb: FormBuilder,
    private userService: UserService,
    private coreService: CoreService,
    private currencyService: CurrencyService,
    private percentPipe: PercentPipe,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.dialogService.closeModal2();
    this.authSub = this.auth.$user.subscribe((user) => {
      this.user = user;
      if (user) {
        // console.log(this.auth.hasShownUserVideo === false && (user.promptUserVideo || user.promptCoachVideo))
        // if (this.auth.hasShownUserVideo === false && (user.promptUserVideo || user.promptCoachVideo)) {
        if ((user.promptUserVideo || user.promptCoachVideo)) {
          // console.log('showing video')
          let vidType: VideoType = 'userWelcomeIndividual';
          if (user.coachId) {
            this.userService.get(user.coachId).subscribe(coach => {
              vidType = coach.coachType === 'coachRevShare' ? 'userWelcomeRev' : 'userWelcomeLead';
              this.latestRef?.close();
              this.showVideo(vidType);
              // this.auth.hasShownUserVideo = true;
              // console.log(this.auth.hasShownUserVideo)
            });
          } else {
            vidType = user.coachType === 'coachRevShare' ? 'coachWelcomeRev' : 'coachWelcomeLead';
            this.latestRef?.close();
            this.showVideo(vidType);
            // this.auth.hasShownUserVideo = true;
            // console.log(this.auth.hasShownUserVideo)
          }
        }
        this.headerService.setConfig({
          title: `Welcome back, ${
            user?.firstName ? user.firstName : user?.displayName
          }`,
          subtitle: `Take a look at your progress (Active since ${user?.dateCreated
            .toDate()
            .toDateString()})`,
          isDashboard: true,
          breadcrumbs: [],
        });
        if (!this.hasShownVideo && (user.promptUserVideo || user.promptCoachVideo)) {
          this.hasShownVideo = true;
          // this.dialogService.openModal(VideoPlayerComponent, {videoType: user.coachId ? 'userWelcome' : 'coachWelcome'}).afterClosed().subscribe(closed => {
          //   this.userService.update({...user, promptUserVideo: false, promptCoachVideo: false});
          // });
        }
      } else {
        this.headerService.resetConfig();
      }
      if (!this.headerConfigSub) {
        this.headerConfigSub = this.headerService.visionChanged.subscribe(changed => {
          let visionSubscription = this.dialogService.openModal(VisionDialogComponent, {currentVision: user?.vision}, undefined).afterClosed().subscribe(newVision => {
            if (newVision) {
              this.user!.vision = newVision;
              this.userService.update(this.user!).then(res => {
                visionSubscription.unsubscribe();
              })
            } else {
              visionSubscription.unsubscribe();
            }
          })
        });
      }
    });
  }


  ngOnDestroy(): void {
    this.coreService.removeSubscription('dashboard');
    this.authSub?.unsubscribe();
    this.headerConfigSub?.unsubscribe();
    this.dialogService.closeModal2();
    this.dialogService.literallyCloseEverything();
  }

  showVideo(videoType: VideoType) {
    this.dialogService.closeModal2();
    this.latestRef?.close();
    this.dialogService.literallyCloseEverything();
    this.latestRef = this.dialogService.openModal(VideoPlayerComponent, {videoType: videoType}, {}, 'sm:w-[75vw]');
  }
}
